import { categories } from '@/mocks/categories';

const finalCategories = categories.slice(11);

const finalImages = [
  'https://readdy.ai/api/search-image?query=Handcrafted%20braided%20cognac%20leather%20belt%20coiled%20elegantly%20on%20warm%20ivory%20linen%20surface%2C%20soft%20natural%20window%20light%20from%20upper%20left%20creating%20gentle%20shadows%2C%20editorial%20product%20photography%20with%20rich%20leather%20grain%20texture%20visible%2C%20warm%20earthy%20tones%20with%20subtle%20brass%20buckle%20detail%2C%20artisanal%20craftsmanship%20focus&width=800&height=960&seq=final-belts-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20botanical%20sprig%20accents%20on%20warm%20ivory%20surface%2C%20diffused%20natural%20light%20creating%20soft%20highlights%20through%20glass%2C%20editorial%20beauty%20product%20photography%20with%20warm%20amber%20tones%20and%20gentle%20reflections%2C%20sophisticated%20minimalist%20composition%20with%20organic%20styling&width=800&height=960&seq=final-perfumes-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Curated%20fashion%20accessories%20flat%20lay%20including%20tortoiseshell%20sunglasses%20silk%20scarf%20and%20delicate%20gold%20toned%20jewelry%20on%20warm%20ivory%20linen%20surface%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%20with%20varied%20textures%20and%20warm%20neutral%20palette%2C%20intentional%20artistic%20composition%20with%20thoughtful%20spacing&width=800&height=960&seq=final-other-v2&orientation=portrait',
];

export default function FinalFeatureGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="text-xs font-medium tracking-widest uppercase text-secondary-600 whitespace-nowrap">More Essentials</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mt-3">
            Complete Your Look
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {finalCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative block rounded-2xl overflow-hidden aspect-[1/1.15] cursor-pointer"
            >
              <img
                src={finalImages[idx]}
                alt={`Superbuy Spreadsheet ${cat.name} category collection`}
                title={`Superbuy Spreadsheet - ${cat.name}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/35 via-transparent to-transparent transition-opacity duration-300 group-hover:opacity-0"></div>
              <div className="absolute inset-0 bg-background-50/0 group-hover:bg-background-50/15 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-6 px-4">
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-1 group-hover:text-foreground-900 transition-colors duration-300">
                  {cat.name}
                </h3>
                <span className="text-xs text-background-50/75 group-hover:text-foreground-600 transition-colors duration-300 whitespace-nowrap">
                  Browse Collection
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}